module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-12 col-form-label",
    attrs: {
      "for": "inputTransitDescription"
    }
  }, [_vm._v("Описание техцентра")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('mavon-editor', {
    attrs: {
      "id": "inputTransitDescription",
      "toolbars": _vm.toolbars,
      "language": "ru"
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', _vm.text)
      }
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1a0bb7a9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-1a0bb7a9"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Techcenter/components/TcTextArea.vue
// module id = 1003
// module chunks = 1